import React, { useContext } from 'react'

import { GlobalContext } from '../../lib-atomic-context'

/* container */
import SubsquadFaqContainer from '../../app-module-subsquadfaq-container/default'
/* container */

import Contents from '../contents/contents'

import ScrollToTop from '../../../scrollToTop'

const index = (props) => {
  return (
    <SubsquadFaqContainer {...props}>
      <ScrollToTop {...props} />
      <Contents {...props} />
    </SubsquadFaqContainer>
  )
}

export default index
